export const ListEditingStylesQueryKey = 'list-editing-styles';
